import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const SearchIcon24 = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0v0Z"
    />
  </Svg>
);
export default SearchIcon24;
